import axios from 'axios'

export const AXIOS = axios.create({ baseURL: `${process.env.REACT_APP_URL}` })

AXIOS.defaults.headers.post["Content-Type"] = "aplication/json"
AXIOS.defaults.headers.common["Authorization"] = ''

// BACKOFFICE SESSION (CLEARED WHEN THE BROWSER TAB IS CLOSED) ---------------------------------
const SESSION_KEY = 'backofficeSession'

export const loadSession = () => {
    try {
        return JSON.parse(window.sessionStorage.getItem(SESSION_KEY)) || null
    } catch (error) {
        return null
    }
}

export const saveSession = session => {
    try {
        window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(session))
    } catch (error) { }
}

export const clearSession = () => {
    try {
        window.sessionStorage.removeItem(SESSION_KEY)
    } catch (error) { }
}

// SEND THE BACKOFFICE TOKEN WITH EVERY REQUEST
AXIOS.interceptors.request.use(config => {
    const session = loadSession()
    if (session?.token) config.headers['X-Admin-Token'] = session.token
    return config
})

// TOKEN MISSING OR EXPIRED : BACK TO THE LOGIN PAGE
AXIOS.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401 && error.response?.data?.code === 'AUTH_REQUIRED') {
            clearSession()
            if (window.location.pathname !== '/') window.location.href = '/?authenticated=false'
        }
        return Promise.reject(error)
    }
)
